<template>
  <div class="forgetPwd">
    <div class="head" @click="$router.go(-1)">
      <svg-icon iconClass="leftArrow" class="backBtn"></svg-icon>
    </div>
    <div class="title">登录</div>
    <!-- 模式选择 -->
    <div class="typeBox">
      <div class="bindType leftBox" :class="{active: bindType == 'phone'}" @click="chageType('phone')">
        <svg-icon iconClass="phone" class="typeIcon" />
        <div>手机号码</div>
      </div>
      <div class="bindType rightBox" :class="{active: bindType == 'email'}" @click="chageType('email')">
        <svg-icon iconClass="email" class="typeIcon" />
        <div>邮箱</div>
      </div>
    </div>
    <!-- 手机号输入框 -->
    <div class="inputBox" v-if="bindType == 'phone'">
      <div class="areaCodeInp">
        <van-field v-model="areaCode" label="+" placeholder="区号" />
      </div>
      <div class="phoneInp">
        <van-field placeholder="请输入手机号" type="tel" v-model="phoneValue" />
      </div>
    </div>
    <div class="emailBox">
      <!-- 邮箱输入框 -->
      <div class="inputBox" v-if="bindType == 'email'">
        <input type="text" class="emailInput" placeholder="请输入您的邮箱账号" v-model="emailValue" @blur="onBlur" @input="onFocus">
      </div>
      <!-- 邮箱自动补全 -->
      <transition name="fade">
        <div class="autoMail-box" v-if="emailArr.length > 0 && isBlur && emailValue">
          <ul>
            <li v-for="(mail, index) in emailArr" @mouseover="current = index" :class="{current: index == current}" :key="mail" @click="chooseMail">{{prefix(emailValue) + mail}}</li>
          </ul>
        </div>
      </transition>
      <!-- 邮箱自动补全 -->
    </div>
    <!-- 验证码输入框 -->
    <div class="inputBox mt24">
      <van-field placeholder="请输入验证码" v-model="veriCode">
        <template #button>
          <div class="timer" v-if="timer">{{timer}}S</div>
          <div v-else class="getCode" @click="countdown">获取验证码</div>
        </template>
      </van-field>
    </div>
    <div class="nextBtn" @click="nextPage">确认</div>
  </div>
</template>

<script>
import { captcha, login } from "@/api/user.js";
export default {
  data() {
    return {
      /**  邮箱自动补全*/
      value: "",
      isBlur: false,
      current: 0, // 当前选中的mail类型
      // 邮箱提示、补全
      emailArr: [
        "qq.com",
        "163.com",
        "126.com",
        "yeah.net",
        "sina.com",
        "aliyun.com",
        "outlook.com",
        "hotmail.com",
        "foxmail.com",
        "yahoo.com",
        "139.com",
        "sohu.com",
        "gmail.com",
      ],
      /**  邮箱自动补全*/
      areaCode: "86",
      emailValue: "",
      phoneValue: "",
      veriCode: "",
      timer: 0,
      bindType: "phone",
    };
  },
  created() {},
  methods: {
    //邮箱自动补全
    prefix(value) {
      // 获取前缀
      let inx = value.indexOf("@");
      if (inx <= 0) return `${value}@`;
      let prefix = value.substr(0, inx);
      return `${prefix}@`;
    },
    onBlur() {
      setTimeout(() => {
        this.isBlur = false;
      }, 200);
    },
    onFocus() {
      this.isBlur = true;
    },
    chooseMail(event) {
      // 选择邮箱li
      let value = event.target.innerHTML;
      this.emailValue = value;
      this.isBlur = false;
    },
    //邮箱自动补全
    // 切换登录模式
    chageType(type) {
      this.bindType = type;
      this.phoneValue = "";
      this.emailValue = "";
      this.veriCode = "";
      this.areaCode = "86";
    },
    // 倒计时
    countdown() {
      let emailReg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,5})$/; //邮箱正则
      if (!this.areaCode && this.bindType == "phone") {
        this.$toast("请输入区号");
        return;
      }
      if (!this.phoneValue && this.bindType == "phone") {
        this.$toast("请输入手机号");
        return;
      }
      if (!emailReg.test(this.emailValue) && this.bindType == "email") {
        this.$toast("请输入正确的邮箱");
        return;
      }
      this.sendCode();
    },
    // 发送验证码
    async sendCode() {
      let req = {
        mobile:
          this.bindType == "phone"
            ? "+" + this.areaCode + this.phoneValue
            : undefined,
        email: this.bindType == "email" ? this.emailValue : undefined,
      };
      let ret = await this.$Api(captcha, req);
      if (ret && ret.code == 200) {
        this.$toast("验证码发送成功");
        this.timer = 120;
        let countdown = setInterval(() => {
          this.timer--;
          if (this.timer <= 0) {
            clearInterval(countdown);
          }
        }, 1000);
        return;
      }
      this.$toast(ret.tip || "验证码发送失败");
    },

    async nextPage() {
      let emailReg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,5})$/; //邮箱正则
      if (!this.areaCode && this.bindType == "phone") {
        this.$toast("区号不能为空");
      }
      if (!this.phoneValue && this.bindType == "phone") {
        this.$toast("请输入手机号");
        return;
      }
      if (!emailReg.test(this.emailValue) && this.bindType == "email") {
        this.$toast("请输入正确的邮箱");
        return;
      }
      if (!this.veriCode) {
        this.$toast("请输入验证码");
        return;
      }
      let req = {
        mobile: this.bindType == 'phone' ? "+" + this.areaCode + this.phoneValue : undefined,
        email: this.bindType == 'email' ? this.emailValue : undefined,
        // code: this.veriCode,
        captcha: this.veriCode,
      };
      this.$toast.loading({
        duration: 0,
      });
      let ret = await this.$Api(login, req);
      this.$toast.clear();
      if (ret && ret.code === 200) {
        this.$toast.clear();
        localStorage.setItem("Authorization", ret.data.token);
        await this.$store.dispatch("user/getUserInfo");
        this.$router.push("/mine");
      } else {
        this.$toast(ret.tip || "登录失败");
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.forgetPwd {
  background: #f6f6f6;

  .head {
    width: 48px;
    height: 44px;
    display: flex;
    align-items: center;

    .backBtn {
      width: 16px;
      height: 16px;
      margin: 0 16px;
    }
  }

  .title {
    margin: 12px 0 34px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }

  .typeBox {
    width: 280px;
    height: 40px;
    display: flex;
    margin: 0 auto 27px;
    font-size: 14px;
    background: $white1;

    .bindType {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 40px;
      color: #707070;

      .typeIcon {
        margin-right: 4px;
        width: 20px;
        height: 20px;
      }
    }

    .leftBox {
      border: 1px solid #707070;
      border-right: 0;
      border-radius: 4px 0 0 4px;
    }

    .rightBox {
      border: 1px solid #707070;
      border-left: 0;
      border-radius: 0 4px 4px 0;
    }

    .active {
      border: 1px solid #2c55ef;
      background: rgba(113, 141, 255, 0.4);
      color: #2c55ef;
    }
  }

  .inputBox {
    overflow: hidden;
    width: 278px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid $greyishBrown;
    margin: 0 auto;
    background: $white1;
    display: flex;
    align-items: center;

    .emailInput {
      width: 100%;
      margin: 10px 22px;
      height: 24px;
      font-size: 14px;
    }

    .emailInput::-webkit-input-placeholder {
      color: #cacbce;
      font-size: 14px;
    }

    .emailInput::-ms-input-placeholder {
      color: #cacbce;
      font-size: 14px;
    }

    .emailInput::-moz-placeholder {
      color: #cacbce;
      font-size: 14px;
    }

    .emailInput::-moz-placeholder {
      color: #cacbce;
      font-size: 14px;
    }

    .timer {
      color: $vermillion;
    }

    .lock {
      width: 20px;
      height: 20px;
      margin-left: 20px;
    }

    .areaCodeInp {
      width: 80px;
      padding: 0 3px;
      box-sizing: border-box;
      border-right: 1px solid $greyishBrown;
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/ .van-field__label {
        width: 8.7px;
        margin: 0;
      }
    }

    .phoneInp {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 198px;

      input {
        width: 70%;
      }
    }
  }

  .nextBtn {
    width: 278px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 27px;
    margin: 0 auto;
    text-align: center;
    color: $white1;
    background: $vermillion;
    margin-top: 28px;
  }

  .mt24 {
    margin-top: 24px;
  }
}
.emailBox {
  position: relative;
}
.autoMail-box {
  top: 50px;
  transform: translate(-50%, 0);
  left: 50%;
  position: absolute;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  margin: 0;
  z-index: 999;
  padding: 10px 5px 10px 10px;
  ul {
    margin: 10px;
    max-height: 280px;
    max-width: 250px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.autoMail-box::-webkit-scrollbar-thumb:window-inactive {
  background: #999;
}
.autoMail-box ul {
  list-style: none;
  min-width: 200px;
  margin: 0;
  padding: 0;
}
.autoMail-box ul li {
  color: #333;
  margin: 0;
  padding: 0;
  line-height: 30px;
  padding: 0 10px;
}
.autoMail-box ul li.current {
  background-color: lightblue;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>